import { questionModalActionTypes } from './Constants';

const initialState = {
	loading: false,
	loadingSubjects: false,
	loadingTopics: false,
	open: false,
	subjects: [],
	chapters: [],
	imageLoading: false,
	imageSrc: null,
	imageName: null,
	preselectedSubject: null,
	preselectedTopic: null,
	editData: {},
};

export default function questionModalReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data, publicLink, fileName } = payload || {};

	switch (type) {
		case questionModalActionTypes.SET_QUESTION_MODAL:
		case questionModalActionTypes.GET_QUESTION_AVAILABLE_SUBJECTS_SUCCESS:
			return {
				...state,
				...data,
				loadingSubjects: false,
			};
		case questionModalActionTypes.GET_QUESTION_AVAILABLE_SUBJECTS:
			return {
				...state,
				loadingSubjects: true,
			};
		case questionModalActionTypes.GET_QUESTION_AVAILABLE_TOPICS:
			return {
				...state,
				loadingTopics: true,
			};
		case questionModalActionTypes.GET_QUESTION_AVAILABLE_TOPICS_SUCCESS:
			return {
				...state,
				...data,
				loadingTopics: false,
			};
		case questionModalActionTypes.GET_QUESTION_AVAILABLE_TOPICS_ERROR:
			return {
				...state,
				loadingTopics: false,
			};
		case questionModalActionTypes.CLEAR_QUESTION_AVAILABLE_TOPICS:
			return {
				...state,
				chapters: [],
			};
		case questionModalActionTypes.UPLOAD_QUESTION_ATTACHMENT_REQUEST:
			return {
				...state,
				imageLoading: true,
			};
		case questionModalActionTypes.UPLOAD_QUESTION_ATTACHMENT_SUCCESS:
			return {
				...state,
				imageLoading: false,
				imageSrc: publicLink,
				imageName: fileName,
			};
		case questionModalActionTypes.UPLOAD_QUESTION_ATTACHMENT_ERROR:
			return {
				...state,
				imageLoading: false,
			};
		case questionModalActionTypes.GET_QUESTION_AVAILABLE_SUBJECTS_ERROR:
			return {
				...state,
				open: false,
				loadingSubjects: false,
			};
		case questionModalActionTypes.CREATE_QUESTION_REQUEST:
		case questionModalActionTypes.UPDATE_QUESTION_REQUEST:
			return {
				...state,
				loading: true,
			};
		case questionModalActionTypes.CREATE_QUESTION_SUCCESS:
		case questionModalActionTypes.UPDATE_QUESTION_SUCCESS:
			return {
				...state,
				loading: false,
				open: false,
			};
		case questionModalActionTypes.CREATE_QUESTION_ERROR:
		case questionModalActionTypes.UPDATE_QUESTION_ERROR:
			return {
				...state,
				loading: false,
			};
		case questionModalActionTypes.CLEAR_QUESTION_STATE:
			return initialState;

		default:
			return state;
	}
}
